import HttpRequest from "../HttpRequest";
import {getItem, addItem, removeItem} from './LocalStorage';
import Route from "../Route"

class AuthenticationAPI {
    static isExternalAuthentication = false;
    static userKey = "user";
    static authKey = "auth";
    static user = null;
    static auth = null;
    static response = null;
    static roles = {
        individual: "individual",
        member: "member",
        accounting_manager: "accounting_manager",
        manager_social_and_mobilization: "manager_social_and_mobilization",
        general_manager: "general_manager",
        president: "president",
        administrator: "administrator",
    };
    static roleLabels = {
        individual: "individual",
        member: "Membre",
        accounting_manager: "Gestionnaire des comptes",
        manager_social_and_mobilization: "manager_social_and_mobilization",
        general_manager: "Manager général",
        president: "Président",
        administrator: "Administrateur",
    };

    static isAuthenticated(){
        return !!AuthenticationAPI.getCurrentUser();
    }

    static getCurrentUser(){
        if(!AuthenticationAPI.user){
            AuthenticationAPI.user = JSON.parse(getItem(AuthenticationAPI.userKey));
        }
        return AuthenticationAPI.user;
    }
    static hasTempPassword(){
        return AuthenticationAPI.getCurrentUser() && AuthenticationAPI.getCurrentUser().hasTempPassword;
    }
    static getCurrentAuth(){
        if(!AuthenticationAPI.auth){
            AuthenticationAPI.auth = JSON.parse(getItem(AuthenticationAPI.authKey));
        }
        return AuthenticationAPI.auth;
    }

    static login(credentials){
        return (new HttpRequest()).request(
            Route.APIMembersAuthLogin,
            "POST",
            null,
            {...credentials}
        ).then((response) => {
            AuthenticationAPI.response = response;
            if(response.data.user.accessToken){
                addItem(AuthenticationAPI.userKey, JSON.stringify(response.data.user));
                removeItem(AuthenticationAPI.authKey);
            }
            return response.status === HttpRequest.statusOk;
        }).catch((error) => {return false;});
    }

    static passwordForgotten(email){
        return (new HttpRequest()).request(
            Route.APIMembersAuthPasswordForgotten,
            "PATCH",
            null,
            {email: email}
        ).then((response) => {
            AuthenticationAPI.response = response;
            return response.status === HttpRequest.statusOk;
        }).catch((error) => {return false;});
    }

    static checkAccess(response){
        if(response.data.auth && response.data.auth.message){
            addItem(AuthenticationAPI.authKey, JSON.stringify(response.data.auth));
            if(response.data.auth.isSessionExpired){
                window.location = Route.Logout.link;
            }
        }
    }

    static logout(){
        (new HttpRequest()).request(
            Route.APIMembersAuthLogout,
            "POST", null,
            {...AuthenticationAPI.user}
        ).then((response) => {
            AuthenticationAPI.response = response;
            return response.status === HttpRequest.statusOk;
        }).catch((error) => {return false;});
        removeItem(AuthenticationAPI.userKey);
        AuthenticationAPI.user = null;
    }

    static userRole(){
        return AuthenticationAPI.getCurrentUser() && AuthenticationAPI.user.hasOwnProperty("role") ? AuthenticationAPI.user.role : null;
    }

    static hasRole(role){
        return AuthenticationAPI.userRole() === role;
    }

    static isAMemberUser(){
        return AuthenticationAPI.hasRole(AuthenticationAPI.roles.member);
    }

    static isAdminUser(){
        return AuthenticationAPI.hasRole(AuthenticationAPI.roles.administrator);
    }

    static isAccountingManagerUser(){
        return AuthenticationAPI.isAdminUser() || AuthenticationAPI.hasRole(AuthenticationAPI.roles.accounting_manager);
    }

    static isGeneralManagerUser(){
        return AuthenticationAPI.isAdminUser() || AuthenticationAPI.hasRole(AuthenticationAPI.roles.general_manager);
    }

    static isPresidentUser(){
        return AuthenticationAPI.isAdminUser() || AuthenticationAPI.hasRole(AuthenticationAPI.roles.president);
    }

    static hasAdminSpaceAuthorization(){
        return AuthenticationAPI.isAccountingManagerUser() || AuthenticationAPI.isGeneralManagerUser() || AuthenticationAPI.isPresidentUser();
    }
}
export default AuthenticationAPI;